var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-seach-wrap"},[(_vm.activeName=='task')?_c('Task'):_vm._e(),_vm._v(" "),(_vm.activeName=='record')?_c('Record'):_vm._e(),_vm._v(" "),(_vm.activeName=='sign')?_c('Sign'):_vm._e(),_vm._v(" "),(_vm.activeName=='template')?_c('Template'):_vm._e(),_vm._v(" "),(_vm.activeName=='setting')?_c('Setting'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7573bcef","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/plus/data/sms/index.vue
// module id = null
// module chunks = 